import { useMemo } from 'react';
import { BULK_GRANULAR_SLA_MANAGEMENT_PATH, GRANULAR_SLA_LANDING_PATH, R2F_THRESHOLD_CONFIG_PATH, BULK_R2F_THRESHOLD_CONFIG_PATH, CORA_PATH } from 'src/core/config/navigationRoutes';
import { useURLSiteParam } from 'src/core/hooks/UseURLSiteParam';
import { getGranularSLAPath } from 'src/utils/Routes';


interface ApplicationRouteUrls
{
    granularSLALanding: string;
    granularSLARoute: string | undefined;
    bulkGranularSLARoute: string;
    r2fThresholdRoute: string;
    bulkR2fThresholdRoute: string;
    coraRoute: string;
}

export function applicationNavigationRoutes(): ApplicationRouteUrls
{
    const siteId = useURLSiteParam();


    const granularSLALanding = GRANULAR_SLA_LANDING_PATH;
    const granularSLARoute = useMemo(
        () => (
            siteId ? getGranularSLAPath( siteId ) : getGranularSLAPath( 'OAK4' )
        )
        , [ siteId ] );

    const bulkGranularSLARoute = BULK_GRANULAR_SLA_MANAGEMENT_PATH;
    const r2fThresholdRoute = R2F_THRESHOLD_CONFIG_PATH;
    const bulkR2fThresholdRoute = BULK_R2F_THRESHOLD_CONFIG_PATH;
    const coraRoute = CORA_PATH;

    return { granularSLALanding, granularSLARoute, bulkGranularSLARoute, r2fThresholdRoute, bulkR2fThresholdRoute, coraRoute };
}
